import { applyMiddleware, compose, createStore } from "redux";
import { persistStore } from "redux-persist";
import persistedReducer from "./ConfigReducer";
import thunk from "redux-thunk";

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export default () => {
  let store = createStore(
    persistedReducer,
    composeEnhancers(applyMiddleware(thunk, thunk)),
  );

  let persistor = persistStore(store);
  return { store: store, persistor: persistor };
};
